import { render, staticRenderFns } from "./LogsDialog.vue?vue&type=template&id=36b5a10f&scoped=true&lang=pug"
import script from "./LogsDialog.vue?vue&type=script&lang=js"
export * from "./LogsDialog.vue?vue&type=script&lang=js"
import style0 from "./LogsDialog.vue?vue&type=style&index=0&id=36b5a10f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b5a10f",
  null
  
)

export default component.exports